import { Suspense, lazy } from 'react';

const SetNewPassword = lazy(() => import('../common/SetNewPassword'));

const SetNewPasswordLazy: React.FC = () => {
    return <Suspense><SetNewPassword/></Suspense>;
}

export default SetNewPasswordLazy;